import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ReminderModel} from 'models';
import {AppRootState} from 'store/appStore';

interface BoardItemDialogState {
    selectedReminder: ReminderModel | null;
}

let initialState: BoardItemDialogState = {
    selectedReminder: null,
};

const boardItemDialogSlice = createSlice({
    name: 'BoardItemDialog',
    initialState,
    reducers: {
        setSelectedReminder: (state, action: PayloadAction<ReminderModel | null>) => {
            state.selectedReminder = action.payload;
        },
    },
});

export const {setSelectedReminder} = boardItemDialogSlice.actions;

export const boardItemDialogSliceReducer = boardItemDialogSlice.reducer;
export const boardItemDialogSelector = (rootState: AppRootState): BoardItemDialogState => rootState.boardItemDialog;
